(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('MainUserDeactivatingConfirmationController', [
            '$uibModalInstance',
            'agendaStatus',
            'input',
            MainUserDeactivatingConfirmationControllerFn]);

    function MainUserDeactivatingConfirmationControllerFn(
        $uibModalInstance,
        agendaStatus,
        input) {
        let viewModel = this;

        viewModel.agendaStatus = agendaStatus;
        let selectedAgenda = agendaStatus.sharedAgendaUsers.find(item => item.agendaId == input.selectedAgenda);
        viewModel.selectedAgendaName = selectedAgenda ? selectedAgenda.caption : undefined;
        
        // cancel
        viewModel.no = () => {
            $uibModalInstance.dismiss();
        };

        // ok
        viewModel.yes = () => {
            $uibModalInstance.close();
        };
    }
})();
